'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './account.routes';
import login from './login';
import signup from './signup';
import changePassword from './change-password';
import forgotPassword from './forgot-password';
import resetPassword from './reset-password';
import activateRequested from './activate-requested';
import preferences from './preferences/preferences.component';
import suiteActivateWebaccess from './activate-suite-webaccess';
import suiteResetWebaccess from './reset-password-suite-webaccess';

export default angular.module('conduuApp.account', [uiRouter, login, signup, changePassword,
  forgotPassword, resetPassword, activateRequested, preferences, suiteActivateWebaccess, suiteResetWebaccess])
  .config(routing)
  .run(function($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function(event, next, nextParams, current) {
      if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/index.js